// Suivi d'encodage — ce qui est COMMUN aux deux chemins d'upload.
//
// Il y a deux uploaders vivants dans l'application, écrits à deux moments
// différents et qui interrogent tous les deux `/admin/videos/:id/status` :
//
//   · course_editor/lib/api.js        — l'éditeur de cours (Svelte)
//   · controllers/video_upload_controller.js — le formulaire de leçon (Stimulus)
//
// ⛔ Ils vivent dans deux bundles esbuild séparés. Ce fichier est donc
// volontairement minuscule et sans dépendance : il est dupliqué dans les deux
// bundles, et c'est le prix à payer pour qu'une seule décision (les paliers,
// le délai d'abandon, la phrase affichée) ne s'écrive pas à deux endroits.
// Le 26/08/2026, la correction du polling n'avait été faite QUE dans api.js —
// le contrôleur Stimulus a gardé son `setInterval(…, 5000)` sans abandon
// pendant deux jours, parce que rien ne reliait les deux.

// L'encodage se fait à la queue leu leu : une seule vidéo à la fois sur le
// serveur (config/queue.yml, file `video_encoding`). Une vidéo peut donc
// attendre son tour longtemps, et pendant tout ce temps l'onglet interroge.
//
// À intervalle fixe de 5 s, ça faisait 12 requêtes par minute et par vidéo en
// attente — soit 720 par heure, pour un fichier qui n'a rien à dire. Le
// palier ci-dessous descend à 143 requêtes sur deux heures : les premières
// secondes restent vives (c'est là que le statut bouge vraiment), puis on
// espace.
export const POLL_PALIERS = [
  { jusqua:      60_000, intervalle:  5_000 }, // 1re minute : le statut bouge
  { jusqua:     300_000, intervalle: 15_000 }, // jusqu'à 5 min
  { jusqua: Infinity,     intervalle: 60_000 } // au-delà : on attend son tour
]

// Deux heures. Passé ce délai, ce n'est plus une file d'attente, c'est une
// panne — et un onglet laissé ouvert la nuit ne doit pas interroger jusqu'au
// matin. Le job lui-même n'a aucun `retry_on` : si le conteneur est tué
// pendant un encodage, la vidéo reste sur `processing` pour toujours et rien
// ne viendrait jamais arrêter la boucle.
export const POLL_ABANDON_MS = 7_200_000

export const MESSAGE_ABANDON =
  "L'encodage n'a pas abouti au bout de 2 heures. La vidéo est envoyée : " +
  "rechargez la page plus tard pour voir où elle en est."

// Le rang dans la file, en toutes lettres. `1` s'écrit « 1re », pas « 1e ».
function rangFr(n) {
  return n === 1 ? "1re" : `${n}e`
}

// La phrase affichée pendant que ça travaille.
//
// ⛔ « Encodage… (queued) » disait le mot de la base de données, pas ce qui
// se passe. Un coach qui lit ça ne sait ni s'il doit attendre 30 secondes ni
// s'il y a trente vidéos devant lui — et c'est exactement la question qu'il
// se pose. `queue_position` vient de Video#queue_position et compte TOUS les
// ateliers, pas seulement le sien.
export function messageEncodage(data) {
  if (data?.status === "queued") {
    const rang = data.queue_position
    if (rang && rang > 1) {
      return `En attente de son tour — ${rangFr(rang)} dans la file`
    }
    return "En attente de son tour — c'est la prochaine"
  }
  if (data?.status === "processing") return "Encodage en cours…"
  if (data?.status === "uploading")  return "Réception du fichier…"
  return "Traitement en cours…"
}
